const PRIMARY_EMAIL = 'nisunajni@gmail.com';
const CC_EMAIL = 'info@nisunajni.com.np';
const FORM_SUBMIT_URL = `https://formsubmit.co/ajax/${PRIMARY_EMAIL}`;

/**
 * Sends form data to nisunajni@gmail.com with info@nisunajni.com.np CC'd via FormSubmit.
 */
export async function submitFormEmail({ formName, fields = {}, files = {} }) {
  const formData = new FormData();
  formData.append('_subject', `Nisunajni Website: ${formName}`);
  formData.append('_captcha', 'false');
  formData.append('_template', 'table');
  formData.append('_cc', CC_EMAIL);

  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      formData.append(key, String(value));
    }
  });

  Object.entries(files).forEach(([key, file]) => {
    if (file instanceof File) {
      formData.append(key, file, file.name);
    }
  });

  const response = await fetch(FORM_SUBMIT_URL, {
    method: 'POST',
    body: formData,
    headers: { Accept: 'application/json' },
  });

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error('Unexpected response from email service.');
  }

  const succeeded = data.success === true || data.success === 'true';
  if (!response.ok || !succeeded) {
    throw new Error(
      typeof data.message === 'string' ? data.message : 'Failed to send your submission. Please try again.'
    );
  }

  return data;
}
